function getEnv(env, defaults) {
  return process.env[env] || defaults;
}

export default {
  DEBUG: getEnv('VUE_APP_DEBUG', false),
  API_URL: getEnv("VUE_APP_API_URL", "http://localhost:8350/v1"),
  ENV: getEnv("NODE_ENV", "development")
};